export const environment = {
  production: true,
  mockLiveMatch: false,
  APIEndpoint: 'https://api.laporrabcn.com/v1',
  webPushPublicKey:
    'BPrDFrY-AGmzEWYy2Q0h9LIh-n8ekEcmlaD4Y_BTbEcu1vJQw39ghrhZMTefWNUebsjhov6tNK_I8Xyc7ZLyX_k',
  Amplitude: {
    APIKey: '6864e5537c9442cdb9a34667d8424942',
  },
};
